import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { FILTER_FIELDS_COLUMNS_CLASS } from './filterFieldsGrid.constants';

interface FilterFieldsGridProps {
  children: ReactNode;
}

export function FilterFieldsGrid({ children }: FilterFieldsGridProps) {
  return (
    <div className="@container">
      <div className={cn('grid gap-3', FILTER_FIELDS_COLUMNS_CLASS)}>{children}</div>
    </div>
  );
}
